import { AssetDTO } from '@gearbelt/global';
import { useQuery } from '@tanstack/react-query';

import { AWAActivityList } from '@/awa-pages/[workspaceId]/assets/[id]/activity/list';
import { SkeletonList } from '@/awa-pages/[workspaceId]/assets/[id]/activity/skeleton-list';
import { getActivityByAssetQueryOptions } from '@/queries/inspections';

export function AWAAssetActivity({ asset }: { asset: AssetDTO }) {
  const { data: activityData, isLoading: activityLoading } = useQuery(getActivityByAssetQueryOptions({ assetId: asset.id }));

  if (activityLoading) {
    return <SkeletonList />;
  }

  return (
    <div className="flex flex-col">
      <AWAActivityList activities={activityData || []} asset={asset} />
    </div>
  );
}
